import {smartJump} from '@qnpm/vc_jump';

export function formatData(data) {
    if(Array.isArray(data)) {
        return data.map(item => {
            return item.data;
        });
    }
    return data.data;
}

export const jump = (jumpInfo = {}, type) => {
    const {appUrl, touchUrl} = jumpInfo;
    if(!appUrl && !touchUrl) return;
    smartJump(hysdk.sniff.qunar ? appUrl || touchUrl : touchUrl, type);
};

export const links = ['https://e.qunar.com/ZtKpkDD', 'https://e.qunar.com/ZtKpkeD', 'https://e.qunar.com/Zt8LcOD'];
export const hotelTabs = ['abu_hotel_top', 'abu_hotel_vip', 'abu_hotel_qinzi', 'abu_hotel_tese'];